import ReactGA from 'react-ga4';
/**
 * Function to set GA userid.
 * @param userId - Id of the user.
 */
export function setUserIdInGa(userId: string): void {
  ReactGA.set({ user_id: userId });
}

// eslint-disable-next-line jsdoc/require-param
/**
 * Function to send custom event to GA.
 * @param category - GA category.
 * @param action - GA action.
 * @param eventData - Additional event data like label, value etc.
 * @param eventData.label - Event label.
 * @param eventData.value - Event value.
 * @param eventData.nonInteraction - Whether event is non-interactive.
 */
export function sendCustomEventToGa(
  category: string,
  action: string,
  eventData?: {
    [key: string]: any;
  }
): void {
  ReactGA.event('user_interaction', {
    category,
    action,
    ...eventData
  });
}

export const GA_CATEGORIES = {
  onboarding: 'onboarding',
  download: 'download'
};
